<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="title" [ttModel]="edit.title" ttReadonly></tt-input>
        <tt-input ttLabel="usergroup_name" [ttModel]="edit.usergroup_name" ttReadonly></tt-input>
        <tt-checkbox ttLabel="access" [(ttModel)]="edit.access"></tt-checkbox>
        <tt-button-save ttText="docarticletopusergroup_save" (ttClick)="saveChanges()" [ttLoading]="saving"></tt-button-save>
    </tt-card>
</tt-page>
